export const PAGE_ERROR_STATE = 'PAGE_ERROR_STATE'
